import { Loader } from '@public/components/Svg/loader';

import styles from './Loading.module.scss';

export const Loading = () => (
  <div className={styles.spinner}>
    <Loader />
  </div>
);
